import * as React from 'react'
import { connect } from 'react-redux'
import { formSelector } from '../../selectors/forms'
import { companyNameSelector, consentIdSelector } from '../../selectors/widget'
import { getForm, submitAnswersFeedbackForm } from '../../actions/forms'
import { RootState } from '../../types/rootstate'
import { FormValues } from '../../reducers/form-values'
import { LoadableFormBuilder } from '../../lib/form-builder/formbuilder-loadable'

interface StateProps {
  form: RootState['forms']['key']
  companyName: string
  consentId: number
}

interface DispatchProps {
  getForm: (userId: number, agentId: number, formId: number) => Promise<void>
  submitAnswersFeedbackForm: (
    userId: number,
    instanceId: string,
    formId: number,
    articleId: number,
    values: FormValues,
    consentId: number,
    fileTokens: string[]
  ) => Promise<void>
}

interface OwnProps {
  userId: number
  formId: number
  articleId?: number
  hasLoaded?: () => void
}

type FeedbackFormProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState, ownProps: OwnProps): StateProps {
  return {
    form: formSelector(state, ownProps.formId),
    companyName: companyNameSelector(state),
    consentId: consentIdSelector(state)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    getForm: (userId, agentId, formId): Promise<void> =>
      dispatch(getForm(userId, agentId, formId)),
    submitAnswersFeedbackForm: (
      userId,
      instanceId,
      formId,
      articleId,
      values,
      consentId,
      fileTokens
    ): Promise<void> =>
      dispatch(
        submitAnswersFeedbackForm(
          userId,
          instanceId,
          formId,
          articleId,
          values,
          consentId,
          fileTokens
        )
      )
  }
}

interface FeedbackFormState {
  isSubmitting: boolean
  showThankYou: boolean
  showError: boolean
}

class FeedbackFormComponent extends React.Component<
  FeedbackFormProps,
  FeedbackFormState
> {
  constructor(props) {
    super(props)

    this.state = {
      isSubmitting: false,
      showThankYou: false,
      showError: false
    }
  }

  componentWillMount(): void {
    if (!this.props.form) {
      this.props
        .getForm(this.props.userId, null, this.props.formId)
        .then(() => {
          this.props.hasLoaded && this.props.hasLoaded()
        })
    } else {
      this.props.hasLoaded && this.props.hasLoaded()
    }
  }

  handleSubmit = (values: FormValues, fileTokens: string[]): void => {
    if (!this.state.isSubmitting) {
      this.setState({
        isSubmitting: true
      })
      this.props
        .submitAnswersFeedbackForm(
          this.props.userId,
          this.getFormInstanceId(),
          this.props.formId,
          this.props.articleId,
          values,
          this.props.consentId,
          fileTokens
        )
        .then(() => {
          this.setState({
            isSubmitting: false,
            showThankYou: true
          })
        })
        .catch((err) => {
          console.error(err)
          this.setState({
            showError: true
          })
        })
    }
  }

  getFormInstanceId(): string {
    return '' + this.props.articleId
  }

  render(): JSX.Element {
    const text = {
      __html: this.props.form && this.props.form.thankyouText
    }
    const showForm =
      this.props.form &&
      this.props.form.status === 'success' &&
      !this.state.showThankYou
    const isLoading = this.props.form && this.props.form.status === 'fetching'

    return (
      <div>
        {isLoading && (
          <div className='loadingSpinner'>
            <div className='accentPrimaryButton imbox-loader'>
              <div />
            </div>
          </div>
        )}
        {showForm && (
          <LoadableFormBuilder
            form={this.props.form.form}
            instanceId={this.getFormInstanceId()}
            formId={String(this.props.formId)}
            userId={this.props.userId}
            type={this.props.form.formType}
            companyName={this.props.companyName}
            onSubmit={this.handleSubmit}
          />
        )}
        {this.state.showThankYou && (
          <div className='feedbackThankYou' dangerouslySetInnerHTML={text} />
        )}
      </div>
    )
  }
}

const FeedbackForm = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackFormComponent)

export { FeedbackForm }
